import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';
import { RegistrationService } from '../registration/registration-service/registration.service';
import { NavbarComponent } from '../shared/components/navbar/navbar.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-registration-admissions-closed',
  templateUrl: './registration-admissions-closed.component.html',
  styleUrls: ['./registration-admissions-closed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavbarComponent, MatIcon],
})
export class RegistrationAdmissionsClosedComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private registrationService = inject(RegistrationService);

  homeUrl = '/';
  readonly schoolInfo = signal<any>({});
  schoolCode = '';

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.schoolCode = params.schoolCode || '';
      this.homeUrl = this.schoolCode ? `/${this.schoolCode}` : '/';
      if (this.schoolCode !== '') {
        this.registrationService.getSchoolInfo(this.schoolCode).subscribe(
          (res: any) => {
            this.schoolInfo.set(res && res.data ? res.data : {});
          },
          () => {
            this.schoolInfo.set({});
          },
        );
      }
    });
  }

  redirectToWelcome(): void {
    if (this.schoolCode !== '') {
      this.router.navigate(['/', this.schoolCode]);
    } else {
      this.router.navigate(['/']);
    }
  }
}
